import type {DataRouterFileOverviewPayload} from '@github-ui/code-view-types'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {RailsPartial, RailsPartialHTML} from '@github-ui/rails-partial'
import {ReposOverview} from '@github-ui/repos-overview/ReposOverview'
import {SplitPageLayout} from '@primer/react'

import {type MergedHeaderPayload, OverviewHeader} from '../components/overview/OverviewHeader'
import {OverviewSidebar} from '../components/overview/OverviewSidebar'
import {useUpdateRefInfoAndPath} from '../hooks/use-update-ref-info-and-path'
import {codeViewRepoRoute} from '../routes/code-view-repo-route'

export function ReposOverviewPage({
  payload,
  isTree,
  sidebarPayload,
}: {
  payload: DataRouterFileOverviewPayload
  isTree: boolean
  sidebarPayload: MergedHeaderPayload
}) {
  useUpdateRefInfoAndPath(payload.refInfo, payload.path)
  const reactSidebarEnabled = isFeatureEnabled('react_data_router_code_view_sidebar')
  const reactHeaderEnabled = isFeatureEnabled('code_view_react_header')

  return (
    <SplitPageLayout className="container-xl">
      <SplitPageLayout.Header padding="none" divider="none" className="tmp-px-3 tmp-px-lg-5">
        {reactHeaderEnabled ? (
          <OverviewHeader overview={payload.overview} headerData={sidebarPayload} />
        ) : isTree ? (
          <RailsPartialHTML html={payload.overview.partials.header} partialName="codeViewTreeRoute.Header" />
        ) : (
          <RailsPartial route={codeViewRepoRoute} partialName="Header" />
        )}
      </SplitPageLayout.Header>
      <SplitPageLayout.Content as="div" padding="condensed">
        <ReposOverview payload={payload} className="tmp-pl-lg-3 mt-0" tree={payload.tree} />
      </SplitPageLayout.Content>
      <SplitPageLayout.Pane position="end" sticky={false} divider="none" width="large" className="pr-2">
        {reactSidebarEnabled ? (
          <OverviewSidebar overview={payload.overview} sidebarPayload={sidebarPayload} />
        ) : isTree ? (
          <RailsPartialHTML html={payload.overview.partials.sidebar} partialName="codeViewTreeRoute.Sidebar" />
        ) : (
          <RailsPartial route={codeViewRepoRoute} partialName="Sidebar" />
        )}
      </SplitPageLayout.Pane>
    </SplitPageLayout>
  )
}
